import { Alert } from './../../common/alert/shared/alert.model';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core'
import { NgForm } from '@angular/forms'
import { Router } from '@angular/router'
import 'rxjs/add/operator/catch'
import { AlertService } from '../../common/alert/shared/alert.service'
import { OperadoraDeMaquinaService } from '../../core/services/operadora-de-maquina.service'
import { EmpresaQueVendeComCartoes } from '../../pkw-data/collect/empresa-que-vende-com-cartoes.model'
import { Exportacao } from '../../pkw-data/collect/exportacao.model'
import { OperadoraDeMaquina } from '../../pkw-data/collect/operadora-de-maquina.model'
import { Empresa } from '../../pkw-data/core/empresa.model'
import { TiposDeMovimentoRelatorio } from '../relatorio/opcoes-relatorio.interface'
import { FileDownloader } from '../shared/file-downloader'
import { FiltroExtrato } from '../shared/filtro-extrato'
import { ConfiguracaoExportacao } from './shared/configuracao-exportacao'
import { ExportacaoFinalizada } from './shared/exportacao-finalizada'
import { ExportacaoService } from './shared/exportacao.service'
import { TIPOS_DE_MOVIMENTO } from '../shared/tipos-de-movimento.const'
import { empty } from 'rxjs/Observer'
import { novoStatus } from './novoStatus';
import { TelemetriaService } from '../../core/services/telemetria.service';


@Component({
    selector: 'col-exportacao-movimento',
    templateUrl: './exportacao-movimento.component.html',
    styleUrls: ['./exportacao-movimento.component.scss'],
})
export class ExportacaoMovimentoComponent implements OnInit, OnChanges {
    @Input() filtro: FiltroExtrato
    @Input() empresasQVCC: EmpresaQueVendeComCartoes[]

    novostatus: any = {}


    empresas: Empresa[]
    operadoras: OperadoraDeMaquina[]
    exportacao: Exportacao
    configuracao: ConfiguracaoExportacao
    tipoDeTransacaoOpt: TipoDeTransacaoOption
    tiposDeTransacaoOpts: TipoDeTransacaoOption[]
    errorMsgs: any
    nome: string
    nova_operadoras: boolean[] = []
    nomeOperadora: string[] = []
    novaOperadora: boolean
    operadora: number
    id: string[] = []
    operadoraNova: boolean[] = []
    aux: number
    formato: string

    constructor(
        private router: Router,
        private operadoraDeMaquinaService: OperadoraDeMaquinaService,
        private exportacaoService: ExportacaoService,
        private alertService: AlertService,
        private telemetriaService: TelemetriaService,
    ) {
        this.exportacao = this.exportacaoService.nova()
        this.configuracao = new ConfiguracaoExportacao(this.exportacao)
    }

    ngOnInit() {
        this.formato = "TXT";
        this.tiposDeTransacaoOpts = TIPOS_DE_MOVIMENTO
        this.errorMsgs = {
            required: 'Campo obrigatório',
        }
        this.operadoraDeMaquinaService.obterTodas().subscribe((operadoras) => {
            this.operadoras = operadoras.filter(e=>e.ativo);
            this.configuracao.setOperadorasDisponiveis(operadoras)
        })

        this.operadoraDeMaquinaService.obterOperadoras().subscribe((operadoras) => {
            this.operadoras = operadoras.filter(e=>e.ativo);
            this.configuracao.setOperadorasDisponiveis(operadoras)
            this.operadora = 0
            this.aux = 0
            for (let i = 0; i < this.operadoras.length; i++) {
                this.nome = this.operadoras[i].nome
                this.nova_operadoras[i] = this.operadoras[i].novaOperadora
                if (this.nova_operadoras[i] === true) {
                    this.operadora = this.operadora + 1
                    this.id[this.aux] = this.operadoras[i].id
                    this.nomeOperadora[this.aux] = this.nome
                    this.operadoraNova[this.aux] = this.nova_operadoras[i]
                    this.aux++
                }
            }

        })
        return
    }

    ngOnChanges(changes: SimpleChanges) {
        this.handleInputChanges(changes)
    }

    exportar(exportacaoForm: NgForm) {
        this.telemetriaService.cadastrarTelemetria("exportar-movimento").subscribe();

        if (exportacaoForm.valid) {            
            this.atualizarFiltro()
            this.exportacaoService
                .gerar(this.configuracao, this.formato)
                .subscribe((exportacaoFinalizada) =>
                    this.baixarArquivo(exportacaoFinalizada)
                )
        }
    }

    atualizarOpcoesTipoDeTransacao() {
        this.configuracao.tipoDeTransacao =
            this.tipoDeTransacaoOpt && this.tipoDeTransacaoOpt.tipo

        if (!this.configuracao.podeApurarTaxaDeRecebimentos) {
            this.exportacao.apuraTaxaDeRecebimentos = false
        }

        if (!this.configuracao.podeApurarTaxaDeVendas) {
            this.exportacao.apuraTaxaDeVendas = false
            this.exportacao.apuraLiquidoDasVendas = false
        }

        if (!this.configuracao.podeApurarBrutoDosRecebimentos) {
            this.exportacao.apuraBrutoDosRecebimentos = false
        }

        if (!this.configuracao.podeSepararPorTipoDeTransacao) {
            this.configuracao.separarPorTipoDeTransacao = false
        }

        if (!this.configuracao.podeSepararPorTipoDeVenda) {
            this.configuracao.separarPorTipoDeVenda = false
        }
    }

    atualizarOpcoesOperadora() {
        if (!this.configuracao.podeSepararPorOperadora) {
            this.configuracao.separarPorOperadora = false
        }
    }

    setEmpresaQVCCConfiguracao(empresa: Empresa) {
        this.exportacao.empresaQueVendeComCartoes = this.empresasQVCC.find(
            (empresaQVCC) => empresaQVCC.empresa === empresa
        )
    }

    enviar(event){
        event = this.novostatus
        this.atualizarDados(event);
        for (let i = 0; i < this.operadora; i++) {

            this.operadoraDeMaquinaService.atualizarNovaOperadora(event.id[i]);
        }
        }

    private atualizarDados(operadoras: OperadoraDeMaquina) {
        const valores = this.novostatus

        valores.id = this.id

    }

    operadora_Nova() {
           return this.operadora > 0
    }

    private baixarArquivo(exportacaoFinalizada: ExportacaoFinalizada) {
        this.exibirAvisos(exportacaoFinalizada.origem)
        this.tratarErros(exportacaoFinalizada)
        if (exportacaoFinalizada.arquivo) {
            FileDownloader.downloadFile(exportacaoFinalizada.arquivo)
        }
    }

    private exibirAvisos(exportacoes: Exportacao[]) {
        exportacoes
            .map((exportacao) => exportacao.avisos)
            .reduce((todos, avisosDaExport) => todos.concat(avisosDaExport), []) //?
            .filter((aviso, i, todos) => todos.indexOf(aviso) === i)
            .forEach((aviso) => {
                if (aviso.includes(CODIGOS_LANCAMENTO_VAZIO)) {
                    this.alertService.alert(aviso, 'Aviso', 'warning', true)
                    this.router.navigate(['configuracao-integracao'])
                } else {
                    this.alertService.success(aviso, 'Aviso', false)
                }
            })
    }

    private tratarErros(exportacaoFinalizada: ExportacaoFinalizada) {
        const exibirErros =
            exportacaoFinalizada.origem.length === exportacaoFinalizada.erros.length

        if (exibirErros) {
            exportacaoFinalizada.erros
                .filter((erro, i, todos) => {
                    const indexDoPrimeiroComMsgIgual = todos.findIndex(
                        (e) => e.todosOsErros === erro.todosOsErros
                    )

                    return indexDoPrimeiroComMsgIgual === i
                })
                .forEach((erro) => {
                    /*
                        Anteriormente, o tratamento para "códigos de lançamento automático não informados" era um 400 do servidor
                        e era tratado aqui. Agora está no método exibirAvisos() pois o servidor não mais emite um erro.
                    */
                    const possuiLancamentoVazio = erro.erros
                        .map((e) => e.includes(CODIGOS_LANCAMENTO_VAZIO))
                        .includes(true)

                    if (possuiLancamentoVazio) {
                        // this.alertService.danger(erro.todosOsErros, 'Aviso')
                        this.alertService.alert(
                            erro.todosOsErros,
                            'Aviso',
                            'warning',
                            true
                        )
                        this.router.navigate(['configuracao-integracao'])
                    } else {
                        this.alertService.alert(erro.todosOsErros, 'Aviso')
                    }
                })
        }
    }

    private handleInputChanges(changes: SimpleChanges) {
        if ('empresasQVCC' in changes) {
            this.atualizarEmpresas()
        }

        if ('filtro' in changes && this.filtro) {
            this.atualizarEmpresaPeriodo()
        }
    }

    private atualizarEmpresas() {
        if (this.empresasQVCC) {
            this.empresas = this.empresasQVCC.map((empresaQVCC) => empresaQVCC.empresa)

            if (
                this.exportacao &&
                !this.exportacao.empresaQueVendeComCartoes &&
                this.empresasQVCC.length > 0
            ) {
                setTimeout(() => {
                    this.exportacao.empresaQueVendeComCartoes = this.empresasQVCC[0]
                }, 500)
            }
        }
    }

    private atualizarEmpresaPeriodo() {
        this.exportacao.inicio = this.filtro.inicio
        this.exportacao.fim = this.filtro.fim
        this.exportacao.empresaQueVendeComCartoes = this.empresasQVCC.find(
            (empresaQVCC) => empresaQVCC.empresa.id === this.filtro.empresa.id
        )
    }

    private atualizarFiltro() {
        this.filtro.empresa = this.exportacao.empresaQueVendeComCartoes.empresa
        this.filtro.operadora = this.exportacao.operadora
        // this.filtro.inicio = this.exportacao.inicio
        // this.filtro.fim = this.exportacao.fim
    }
}

export interface TipoDeTransacaoOption {
    tipo: TiposDeMovimentoRelatorio
    descricao: string
}

// const CODIGOS_LANCAMENTO_VAZIO =
//     'Não existem códigos de lançamentos automáticos configurados.'

const CODIGOS_LANCAMENTO_VAZIO =
    // tslint:disable-next-line:max-line-length
    'os códigos de lançamento automático não estão informados na configuração de integração'



// WEBPACK FOOTER //
// ./src/app/extratos/exportacao-movimento/exportacao-movimento.component.ts